import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AirdropDashboardLayer from "../../components/AirdropCampagin/AirdropDashboardLayer";
import AirdropCardLayer from "../../components/AirdropCampagin/AirdropCardLayer";

const AirdropDashboardPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Airdrop Campaign" />
        <AirdropCardLayer />
        <AirdropDashboardLayer />
      </MasterLayout>
    </>
  );
};

export default AirdropDashboardPage;
